export const SET_AUTH_STATUS = 'AUTH_SET_STATUS';
export const SET_USER_INFO = 'AUTH_SET_USER_INFO';
export const SET_PARAMETERS_INFO = 'SET_PARAMETERS_INFO';
export const SET_DECODED_TOKEN = 'SET_DECODED_TOKEN';
